module.exports = __webpack_public_path__ + "static/img/diamond_icon2.4551d370.png";